import { WireAnalytics, WireFormData } from 'scenes/common/types';

export enum WireFlowTypeName {
  QuoteDetails = 'get-quote',
  CoverOptions = 'cover-options',
  PolicyDetails = 'policy-details',
  PaymentDetails = 'payment',
  Unknown = '',
}

export enum WireFlowTypeNumber {
  QuoteDetails = 'step1',
  CoverOptions = 'step2',
  PolicyDetails = 'step3',
  PaymentDetails = 'step4',
  Unknown = '',
}

export type WireLandlordFormData = WireFormData & {
  quoteAmountWithExtras: string;
  buildingExcessAmount: string;
  contentsExcessAmount: string;
};

export type WirePropertyData = {
  typeOfBuilding: string;
  riskPostcode: string;
};

export type WireLandlordAnalytics = WireAnalytics & {
  formData: WireLandlordFormData;
  property?: WirePropertyData;
};
